var React = require('react');

function IconCloseModal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.411 8.014 6.286-6.295A1 1 0 0 0 14.286.306L7.99 6.6 1.704.296A1 1 0 0 0 .293 1.709l6.286 6.295-6.286 6.294a1 1 0 0 0 .71 1.704c.26 0 .51-.1.711-.29L8 9.417l6.286 6.295c.2.2.45.29.71.29.26 0 .511-.1.711-.29a1 1 0 0 0 0-1.414L9.411 8.014Z"}));
}

IconCloseModal.defaultProps = {"role":"img","aria-label":"Close","viewBox":"0 0 16 17","fill":"none"};

module.exports = IconCloseModal;

IconCloseModal.default = IconCloseModal;
